/** Adres karty uczestnika — cel przewinięcia po „Dodaj uczestnika”. */
export const participantCardId = (index: number) => `participant-${index}`;
